import {useState} from 'react';

import {AfriexAdminPermission} from '@afriex/core/domain/enums';

import {Button} from '@/components';
import {PermissionsProvider} from '@/components/common/PermissionsProvider';
import type {AfriexCountry} from '@/types';

import ReferralSettingsModal from './ReferralSettingsModal';

type ReferralSettingsProps = {
  handleSave: (id: string, body: Partial<AfriexCountry>) => Promise<void>;
  item: AfriexCountry;
};

const ReferralSettings = ({item, handleSave}: ReferralSettingsProps) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="flex justify-end mb-6">
        <PermissionsProvider permission={AfriexAdminPermission.CountryUpdate}>
          <Button variant={'solid'} onClick={() => setShowModal(!showModal)}>
            Update Settings
          </Button>
        </PermissionsProvider>
      </div>
      <div className="flex flex-col gap-3">
        <div className="overflow-x-auto">
          <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 dark:bg-gray-900 justify-between">
            <p className="text-slate-500 dark:text-slate-100 text-sm">
              Referral Transaction Threshold (in days)
            </p>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-100 w-1/2">
              {item?.params?.referralParams?.cumulativeThreshold || 'Not Set'}
            </p>
          </div>
          <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 dark:bg-gray-900 justify-between">
            <p className="text-slate-500 text-sm dark:text-slate-100">
              Bonus Amount Per Referrer
            </p>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-100 w-1/2">
              {item?.params?.referralParams?.bonusAmountPerReferrer ??
                'Not Set'}
            </p>
          </div>
          <div className="mb-2 py-2 px-3 flex items-center gap-3 bg-gray-100 dark:bg-gray-900 justify-between">
            <p className="text-slate-500 dark:text-slate-100 text-sm">
              Bonus Amount Per Referree
            </p>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-100 w-1/2">
              {item?.params?.referralParams?.bonusAmountPerReferee ?? 'Not Set'}
            </p>
          </div>
        </div>
      </div>

      <ReferralSettingsModal
        onClose={() => setShowModal(!showModal)}
        showModal={showModal}
        handleSave={handleSave}
        item={item}
      />
    </>
  );
};

export default ReferralSettings;
